import React from "react";
import "./floor/floor.css";
import { EngineV2Board, useEngineV2 } from "./floor/FloorTvV2";

export default function EngineV2Tab() {
  const d = useEngineV2();
  return (
    <div className="fc-room h-full overflow-y-auto p-3 lg:p-5" data-testid="engine-v2-tab">
      <p className="nx-orbitron text-sm tracking-[0.3em] text-[#00F0FF] mb-3">ENGINE V2 · MOMENTUM DAY TRADES</p>
      <div className="min-h-[70vh]"><EngineV2Board d={d} /></div>
    </div>
  );
}
